"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowLessButton = void 0;
const react_1 = __importDefault(require("react"));
const ProviderTabs_styles_1 = require("../ProviderTabs.styles");
const button_1 = __importDefault(require("@kyruus/button"));
const ShowLessButton = ({ onClick }) => {
    return (react_1.default.createElement(ProviderTabs_styles_1.ButtonContainer, null,
        react_1.default.createElement(button_1.default, { mode: "flat", onClick: onClick, "data-testid": "show-less-btn" }, "Show Less")));
};
exports.ShowLessButton = ShowLessButton;
//# sourceMappingURL=ShowLessButton.js.map